export default "__VITE_ASSET__vIfNbk_m__"